export default "__VITE_ASSET__ftTcdAol__"